import { createFileRoute } from '@tanstack/react-router';
import AccessoryDetailPage from '@/pages/AccessoryDetailPage';
import { loadShopifyCatalog } from '@/seo/shopifyRouteCatalog';

// Fetch before server rendering. The same catalog drives the visible product
// price / availability and Google's structured offer in the initial HTML.
export const Route = createFileRoute("/accessoires/$slug/")({
  loader: loadShopifyCatalog,
  component: ProductRoute,
});

function ProductRoute() {
  const initialProducts = Route.useLoaderData();
  return <AccessoryDetailPage initialProducts={initialProducts} />;
}
